<div class="clearfix">
  <div class="hint-text">
    Showing <b>{{ pagedItemsSize }}</b> out of <b>{{ totalItems }}</b> entries
  </div>

  <ul class="pagination">
    <li class="page-item">
      <button (click)="goToPreviousBlock()" [disabled]="visiblePages[0] === 1">Précédente</button>
    </li>

    <li class="page-item" *ngIf="visiblePages[0] > 1">
      <button disabled>...</button>
    </li>

    <li class="page-item" *ngFor="let page of visiblePages">
      <button (click)="onPageChange(page)" [class.active]="page === currentPage">{{ page }}</button>
    </li>

    <li class="page-item" *ngIf="visiblePages[visiblePages.length - 1] < pages.length">
      <button disabled>...</button>
    </li>

    <li class="page-item">
      <button (click)="goToNextBlock()" [disabled]="visiblePages[visiblePages.length - 1] === pages.length">Suivant</button>
    </li>
  </ul>
</div>
